






import { Component, Vue } from 'vue-property-decorator'

@Component
export default class SubNavigationCardList extends Vue {

    get componentClasses(): object {
        return {
            'new-navigation-submenu-card-list': true,
        }
    }
}

